<div class="ngx-dialog goreact-modal default-ai-markers-dialog-container" cdkTrapFocus>
  <div class="goreact-modal-header">
    <span class="header-label">
      <h4 class="modal-title">{{'default-ai-marker-title' | translate}}</h4>
    </span>
    <button type="button" class="close-btn" (click)="cancel()" attr.aria-label="{{ 'common_close' | translate }}">
      <i class="ficon-app-x"></i>
    </button>
  </div>

  <div class="goreact-modal-body">
    <div>{{ 'default-ai-marker-dialog-sub-title' | translate }}</div>
    @if ((loading$ | async) === false) {
      <div class="markers-container">
        @if ((allLlmDefinitions$ | async); as allPrompts) {
          <div>
            <div class="use-types-container">
              <mat-form-field goSelect>
                <mat-label>{{ 'default-ai-marker-dialog-use_type' | translate }}</mat-label>
                <mat-select
                  disableOptionCentering
                  panelClass="offsetPanel"
                  (selectionChange)="filterUseType($event.value)"
                  [value]="selectedUseType">
                  @for (type of useTypes; track type) {
                    <mat-option
                      [value]="type">
                      {{ type.name }}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
              </mat-form-field>
              @if (allPrompts.length > 0) {
                <span class="marker-count"> ({{ allPrompts.length }}) </span>
              }
            </div>
            <div class="markers">
              @for (prompt of allPrompts; track prompt) {
                <div class="marker-item">
                  <marker [marker]="prompt.tags[0]" [aiStyle]="true" [withName]="true"></marker>
                  <div class="prompt-description">{{ prompt.description }}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="goreact-modal-footer">
    <button class="tertiary-btn cancel-btn goreact-btn" (click)="cancel()" translate="common_cancel"></button>
    <button class="primary-btn save-btn goreact-btn" (click)="save()">{{ (mode === 'add' ? 'common_add' : 'common_save') | translate }}</button>
  </div>
</div>
